import { ApplicationElement, html } from '@beunity/lit-components';
import style from './style.lit.css';

/**
 * Wrapper component for many types of content (usually lists).
 *
 * @prop horizontal - Main content will have horizontal layout if set to true, otherwise vertical
 * @prop overflow - Main content will have scroll overflow if set to true, otherwise it will be hidden
 * @prop gap - The gap between main content items (options: /, sm, md, lg, xl) defaults to 0
 *
 * @slot default - Main slot for list content
 * @slot left - Header start position
 * @slot right - Header end position
 * @slot bottom-right - Footer end position
 *
 * @cssprop --list-gap - The gap between main content items
 * @cssprop --background - Component background
 * @cssprop --max-height - For limiting main slot height. Can activate overflow scroll in combination with overflow attribute
 */

export default class List extends ApplicationElement {
  static styles = [ApplicationElement.styles, style];

  static properties = {
    gap: { type: String, reflect: true },
    horizontal: { type: Boolean, reflect: true },
    overflow: { type: Boolean, reflect: true },
    hasHeaderLeftContent: { type: Boolean, state: true },
    hasHeaderRightContent: { type: Boolean, state: true },
    hasFooterContent: { type: Boolean, state: true },
  };

  get hasHeaderContent() {
    return this.hasHeaderLeftContent || this.hasHeaderRightContent;
  }

  handleSlotChange(e) {
    const childNodes = e.target.assignedNodes({ flatten: true });
    const hasNodes = childNodes.length > 0;

    if (e.target.name === 'left') {
      this.hasHeaderLeftContent = hasNodes;
    } else if (e.target.name === 'right') {
      this.hasHeaderRightContent = hasNodes;
    } else if (e.target.name === 'bottom-right') {
      this.hasFooterContent = hasNodes;
    }
  }

  render() {
    return html`
      <div class="section">
        <header ?hidden=${!this.hasHeaderContent}>
          <slot name="left" @slotchange=${this.handleSlotChange}></slot>
          <slot name="right" @slotchange=${this.handleSlotChange}></slot>
        </header>
        <slot></slot>
        <footer ?hidden=${!this.hasFooterContent}>
          <slot name="bottom-right" @slotchange=${this.handleSlotChange}></slot>
        </footer>
      </div>
    `;
  }
}

customElements.get('bu-list') || customElements.define('bu-list', List);
